import { Copy, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { copyText } from "@/lib/copy";

export const PasswordDialog = ({ data, onClose }) => {
  const pwd = data?.temp_password || data?.password;
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-[#C2410C]" /> Mot de passe {data?.temp_password ? "temporaire" : "défini"}</DialogTitle>
          <DialogDescription>
            {data?.email ? `Compte ${data.email}. ` : ""}
            {(data?.password_emailed ?? data?.emailed) ? "Il a été envoyé par e-mail à l'utilisateur." : `Il n'a pas été envoyé par e-mail${data?.email_error ? ` (${data.email_error})` : ""} : communiquez-le vous-même.`}
            {" "}Notez-le : il ne sera plus affiché.
          </DialogDescription>
        </DialogHeader>
        <code onClick={() => copyText(pwd, "Mot de passe copié")} className="block cursor-copy rounded-md bg-stone-900 text-amber-200 p-4 text-lg font-mono tracking-wider select-all" data-testid="password-value">{pwd}</code>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => copyText(pwd, "Mot de passe copié")} data-testid="password-copy"><Copy className="h-4 w-4 mr-1.5" /> Copier</Button>
          <Button className="bg-[#C2410C] hover:bg-[#9A3412] text-white" onClick={onClose} data-testid="password-close">Fermer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
